import { render, staticRenderFns } from "./cadastrar_agendamento_cliente.vue?vue&type=template&id=3d34687f&scoped=true&"
import script from "./cadastrar_agendamento_cliente.vue?vue&type=script&lang=js&"
export * from "./cadastrar_agendamento_cliente.vue?vue&type=script&lang=js&"
import style0 from "./cadastrar_agendamento_cliente.vue?vue&type=style&index=0&id=3d34687f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d34687f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCardActions,VIcon,VSelect,VSpacer,VTextarea,VToolbar,VToolbarItems,VToolbarTitle})
